import TooltipMui, { TooltipProps } from '@mui/material/Tooltip';

export const Tooltip = ({ ...props }: TooltipProps) => {
  return (
    <TooltipMui
      {...props}
      PopperProps={{
        sx: {
          '& .MuiTooltip-tooltip': {
            fontSize: '0.875rem',
            border: `1px solid #363636`,
            bgcolor: 'var(--color-grey-darker)',
            color: '#fff',
            p: '0.625rem 0.75rem',
            '.theme-light &': {
              border: `1px solid var(--color-grey-light)`,
              bgcolor: 'var(--color-white)',
              color: 'var(--text-primary)',

              boxShadow: '0 0 6px 1px rgba(0,0,0,0.2)',
              fontWeight: 'var(--font-weight-regular)',
            },
            '& .MuiTooltip-arrow': {
              color: 'var(--color-grey-darker)',
              '&::before': {
                border: '1px solid #363636',
              },
              '.theme-light &': {
                color: 'var(--color-white)',
                '&::before': {
                  border: '1px solid var(--color-grey-light)',
                },
              },
            },
          },
        },
      }}
      arrow
    />
  );
};
